{
  "version": 1,
  "gameId": "minesweeper",
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "minesweeper.rules.navigationLabel",
    "kickerKey": "minesweeper.rules.kicker",
    "titleKey": "minesweeper.rules.title",
    "summaryKey": "minesweeper.rules.summary",
    "sections": [
      { "id": "setup", "key": "minesweeper.rules.setup" },
      { "id": "clues", "key": "minesweeper.rules.clues" },
      { "id": "controls", "key": "minesweeper.rules.controls" },
      { "id": "flags", "key": "minesweeper.rules.flags" },
      { "id": "finish", "key": "minesweeper.rules.finish" },
      { "id": "challenge", "key": "minesweeper.rules.challenge" }
    ],
    "settingsAccess": false
  },
  "economy": {
    "offlineEntryCoins": 0,
    "offlineWinCoins": 0,
    "offlineWinXp": 20,
    "offlineLossXp": 0,
    "onlineEntryCoins": 0,
    "onlineWinCoins": 0,
    "onlineWinXp": 0,
    "onlineLossXp": 0
  },
  "cosmetics": {}
}
